module.exports = __webpack_public_path__ + "static/media/upArrowIconDark.362de465.svg";